import React from 'react'
import './transperantLoader.css'

const TransperentLoader = () => {
    return (
        <div className="transperent-loader-overlay">
            <div className="transperent-loader"></div>
        </div>
    );
}

export default TransperentLoader